import {
  defaultSharedCapTableSettings,
  SharedCapTableSettings,
  SharedCapTableViewOptions,
} from '../../../hooks/shared-cap-table/shared-cap-table.types';
import { DetailsSortVariant } from '../../../types/snapshot.types';

/**
 * Compared field by field rather than serialised: `settings` is a jsonb column and Postgres stores
 * its keys in its own order — by length, then bytewise — so the value read back never matches a
 * literal written in declaration order. Column arrays are compared as sets for a second reason:
 * toggling a column off and on again moves it to the end without changing what is shared.
 */
const sameColumns = (left: string[], right: string[]): boolean =>
  left.length === right.length && [...left].sort().join() === [...right].sort().join();

const sameViewOptions = (
  left: SharedCapTableViewOptions,
  right: SharedCapTableViewOptions,
): boolean =>
  left.hideOverallStatus === right.hideOverallStatus &&
  left.hideOwnershipChart === right.hideOwnershipChart &&
  left.hideStakeholderNames === right.hideStakeholderNames;

export const isDefaultSharedView = (settings: SharedCapTableSettings): boolean => {
  const defaults = defaultSharedCapTableSettings();

  return (
    settings.allowExport === defaults.allowExport &&
    settings.defaultView === defaults.defaultView &&
    sameViewOptions(settings.viewOptions, defaults.viewOptions) &&
    Object.values(DetailsSortVariant).every((view) =>
      sameColumns(settings.columns[view], defaults.columns[view]),
    )
  );
};
